import { Link } from "react-router-dom";
import "../App.css";

export default function Album() {
  return (
    <div className="App">
      <div className="container">
        <div className="title">NOTHING IS EVER WRONG</div>
        <div className="content-2">
          <div className="text-2">
            <a href="https://open.spotify.com/album/500SrCiKA4oB6BkZVJrcoH?si=ScxxyqQgSIKQe1ienlHMpg">
              SPOTIFY
            </a>
          </div>
          <div className="text-2">
            <a href="https://music.apple.com/us/album/nothing-is-ever-wrong/1822897018">
              APPLE
            </a>
          </div>
          <div className="text-2">
            <a href="https://music.amazon.com/albums/B0FF5QWC3Z?marketplaceId=ATVPDKIKX0DER&musicTerritory=US&ref=dm_sh_6G06YBazxRk6cXWcwPXMyuNYT">
              AMAZON
            </a>
          </div>
          <div className="text-2">
            <a href="https://music.youtube.com/playlist?list=OLAK5uy_kyOmOo7ZW8hdK8L1scMk04ReTRL4TCPQY&feature=shared">
              YOUTUBE
            </a>
          </div>
          <div className="text-2">
            <a href="https://tidal.com/browse/album/443840560">TIDAL</a>
          </div>
          <div className="text-2">
            <a href="https://link.deezer.com/s/30lXm6FhO6ELjIG5qhQoN">DEEZER</a>
          </div>
        </div>
        <div className="links">
          <Link to="/">home</Link>
        </div>
      </div>
    </div>
  );
}
